import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
const ClearCache = () => {
	var cachedContent =
		localStorage.getItem("TrackmanIP") ||
		localStorage.getItem("clubInfo") ||
		localStorage.getItem("sessionId") ||
		localStorage.getItem("fittingStartedSessionId") ||
		localStorage.getItem("fitterName") ||
		localStorage.getItem("locationId") ||
		localStorage.getItem("sessionData")
			? true
			: false;
	return (
		<>
			{cachedContent ? (
				<Tooltip title="Delete cached data">
					<IconButton
						onClick={() => {
							localStorage.removeItem("TrackmanIP");
							localStorage.removeItem("clubInfo");
							localStorage.removeItem("clubFetchDate");
							localStorage.removeItem("gender");
							localStorage.removeItem("sessionId");
							localStorage.removeItem("fittingStartedSessionId");
							localStorage.removeItem("fitterName");
							localStorage.removeItem("rightHanded");
							localStorage.removeItem("clubType");
							localStorage.removeItem("handicap");
							localStorage.removeItem("locationId");
							localStorage.removeItem("sessionData");
							localStorage.removeItem("LocationList");
							localStorage.removeItem("fitterList");
							localStorage.removeItem("ballFittingCompleted");
							window.location = window.location.origin;
						}}
					>
						<DeleteIcon sx={{ color: "white" }} />
					</IconButton>
				</Tooltip>
			) : null}
		</>
	);
};

export default ClearCache;
